import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, CheckCircle, Shield, Clock } from 'lucide-react';

const Assessment = () => {
  const navigate = useNavigate();

  const handleBeginAssessment = () => {
    navigate('/intake');
  };

  return (
    <div className="page-assessment-start">
      <div className="assessment-start-container">
        {/* Hero Section */}
        <div className="assessment-start-hero">
          <p className="assessment-start-eyebrow">Glow Health LLC</p>
          <h1 className="assessment-start-title">Hormone Health Assessment</h1>
          <p className="assessment-start-subtitle">
            Take our free 2-minute assessment to discover if hormone imbalance may be 
            contributing to your symptoms. Get personalized insights based on your answers.
          </p>
          
          <button 
            onClick={handleBeginAssessment}
            className="btn-begin-assessment"
            data-testid="begin-assessment-btn"
          >
            Begin My Assessment
            <ArrowRight size={20} />
          </button>
          
          <p className="assessment-start-note">
            Takes about 2 minutes • Private & confidential • No commitment
          </p>
        </div>

        {/* What to Expect Section */}
        <div className="assessment-start-info">
          <h2 className="assessment-info-title">What to Expect</h2>
          
          <div className="assessment-info-grid">
            <div className="assessment-info-card">
              <Clock className="assessment-info-icon" />
              <h3>Quick & Easy</h3>
              <p>Answer a few questions about your symptoms, energy levels, and health goals.</p>
            </div>
            
            <div className="assessment-info-card">
              <CheckCircle className="assessment-info-icon" />
              <h3>Personalized Results</h3>
              <p>Receive insights tailored to your unique symptoms and health profile.</p>
            </div>
            
            <div className="assessment-info-card">
              <Shield className="assessment-info-icon" />
              <h3>Private & Secure</h3>
              <p>Your information is protected and never shared with third parties.</p>
            </div>
          </div>
        </div>

        {/* Symptoms Section */}
        <div className="assessment-start-symptoms">
          <h2 className="assessment-symptoms-title">Common Signs of Hormone Imbalance</h2>
          <div className="assessment-symptoms-grid">
            <div className="symptom-tag">Fatigue & Low Energy</div>
            <div className="symptom-tag">Unexplained Weight Changes</div>
            <div className="symptom-tag">Brain Fog & Difficulty Concentrating</div>
            <div className="symptom-tag">Mood Swings & Anxiety</div>
            <div className="symptom-tag">Sleep Problems</div>
            <div className="symptom-tag">Hot Flashes & Night Sweats</div>
            <div className="symptom-tag">Low Libido</div>
            <div className="symptom-tag">Hair Loss or Thinning</div>
          </div>
          <p className="assessment-symptoms-note">
            If you're experiencing any of these symptoms, our assessment can help identify 
            potential hormone-related causes.
          </p>
        </div>

        {/* CTA Section */}
        <div className="assessment-start-cta">
          <h2>Ready to Get Started?</h2>
          <p>Take the first step toward understanding your hormone health.</p>
          <button 
            onClick={handleBeginAssessment}
            className="btn-begin-assessment"
            data-testid="begin-assessment-btn-bottom"
          >
            Start Free Assessment
            <ArrowRight size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Assessment;
